
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class H5Mark extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: String, default: "" }) title?: string;
  @Prop({ type: String, default: "" }) icon?: string;
  @Prop({ type: String, default: "" }) submitText?: string;
  @Prop({ type: String, default: "" }) innerHeight?: string;
  @Prop({ type: Boolean, default: false }) disabled?: boolean;
  @Prop({ type: Boolean, default: true }) showBg?: boolean;

  handleClose() {
    this.$emit("update:visible", false);
  }

  @Emit()
  handleSubmit() {
    return;
  }
}
